var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectField',_vm._b({attrs:{"rules":[_vm.valid],"items":_vm.cond_items,"original_value":_vm.original_value},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'SelectField',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }